import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import draggable from 'vuedraggable'

export default {
    name: 'HomePhotos',
    created,
    data,
    methods,
    mounted,
    components: {
        draggable
    }
}
